import GA4 from "react-ga4";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export function GoogleAnalytics({
  gaId,
  enabled,
}: {
  gaId: string;
  enabled?: boolean;
}) {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (enabled) {
      GA4.initialize(gaId);
      setInitialized(true);
    }
  }, [enabled]);

  useEffect(() => {
    if (initialized) {
      GA4.set({ page: location.pathname });
      GA4.send("pageview");
    }
  }, [initialized, location]);

  return null;
}
